import Phaser from 'phaser';
import type { PlayerProfile } from '@core/state/PlayerProfile';
import type { AudioService } from '@core/services/AudioService';

/** Clave bajo la cual el perfil del jugador vive en el registry global de Phaser. */
export const PLAYER_PROFILE_REGISTRY_KEY = 'playerProfile';

/** Clave bajo la cual el servicio de audio vive en el registry global de Phaser. */
export const AUDIO_REGISTRY_KEY = 'audioService';

/**
 * Escena base de la que heredan todas las escenas del juego. Centraliza utilidades
 * comunes (acceso al perfil del jugador, audio, centro de pantalla) para evitar
 * repetir codigo en cada escena.
 */
export abstract class BaseScene extends Phaser.Scene {
  protected get profile(): PlayerProfile {
    return this.registry.get(PLAYER_PROFILE_REGISTRY_KEY) as PlayerProfile;
  }

  protected get audio(): AudioService {
    return this.registry.get(AUDIO_REGISTRY_KEY) as AudioService;
  }

  protected get centerX(): number {
    return this.scale.width / 2;
  }

  protected get centerY(): number {
    return this.scale.height / 2;
  }
}
